module.exports = __webpack_public_path__ + "assets/img/to_medinbd.38047516.png";